import {PASS_CONFIGS_EN_US} from "./configs_en-us";
import {PASS_CONFIGS_ES_MX} from "./configs_es-mx";

function getConfigForLocale(locale){
  switch (locale) {
    case 'es-mx':
      return PASS_CONFIGS_ES_MX;
    default:
      return PASS_CONFIGS_EN_US;
  }
}

export default getConfigForLocale;